import { EMainProductCodeType } from '@aqx-core/common/api/config';

import { ECustomerType } from '../../account';
import { ECrmType } from '../../user-account';

export enum ELoginSource {
  WEB = 'WEB',
  MOBILE_WEB = 'MOBILE_WEB',
  DESKTOP_APP = 'DESKTOP_APP',
  ANDROID_APP = 'ANDROID_APP',
  IOS_APP = 'IOS_APP'
}

export enum ELoginAs {
  LIVE = 'LIVE',
  MT4_LIVE = 'MT4_LIVE',
  MT4_DEMO = 'MT4_DEMO',
  MT5_LIVE = 'MT5_LIVE',
  MT5_DEMO = 'MT5_DEMO',
  OMS_DEMO = 'OMS_DEMO',
  OMS_LIVE = 'OMS_LIVE'
}

export enum ELoginMethod {
  PASSWORD = 0,
  EMAIL = 1,
  SMS = 2
}

export enum EOTPType {
  SMS = 1,
  EMAIL = 2
}

// Auth APIs params
export interface ILoginWebParams {
  userId: string;
  password: string;
  source: ELoginSource;
  browserType?: string;
  deviceType?: string;
  loginType?: ELoginMethod;
}

export interface ILoginMobileParams extends ILoginWebParams {
  deviceId: string;
}

export interface IChangePasswordParams {
  confirmPassword: string;
  newPassword: string;
  oldPassword: string;
}

// Auth APIs responses
export interface ILoginResponse {
  token: string;
  user: IAuthUserDetails;
}

export interface ILoginErrorResponse {
  lockedUntil?: number;
}

export interface IAuthUserDetails {
  source: string;
  metatraderId: number;
  metatraderGroup: string;
  isDemo: boolean;
  traderSubscription: string;
  marketSubscription: string;
  tenantId: string;
  mainProductCode: EMainProductCodeType;
  omsServerId: string;
}

export interface ISignUpCrmBasicParams {
  email: string;
  password: string;
  customerType: ECustomerType;
  countryId: number;
}

export interface ISignUpCrmVerificationParams {
  otp: string;
}

export interface ISignUpCrmParams extends ISignUpCrmBasicParams, ISignUpCrmVerificationParams {
  crmType: ECrmType;
}

export interface IRequestCrmOtpParams {
  crmType: ECrmType;
  clientPortalUrl?: string;
  email?: string;
  phoneNumber?: string;
  countryCode?: string;
  type: EOTPType;
}

export interface IForgotPasswordLiveParams {
  email: string;
  metatraderId?: string;
}

export interface IForgotPasswordLiveResponse {
  code: string;
  message?: string;
  result?: boolean;
}

export interface IExperienceLoginParams {
  token: string;
  source: ELoginSource;
  browserType?: string;
  deviceType?: string;
}

export interface IRequestCrmOtpResponse {
  sessionId: string;
  userId: string;
  message: string;
  createdTime: number;
  expiryTime: number;
  timeoutInSec: number;
}
